import "./assets/styles/main.css";
import Header from "./components/Header";
import Hero from "./pages/Home/Hero";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
    </div>
  );
}

export default App;
